import React, { Children, FC, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkIsUrlExternal } from '../../../utils/links-helper/links-helper';
import { joinStrings } from '../../../utils/string';
import { openNewWindow } from '../../Navigation/NavigationLink/helper';
import { Link } from '../../shared/Link';
import { Paragraph } from '../../shared/Paragraph';
import { GeneralListProps } from '../types';
import { useUserContext } from '../../../providers/UserProvider';
import './styles';
import LazyLoadedImage from '../../Media/LazyLoadedImage';

interface LinkWrapperProps {
  disableImages?: boolean;
  linksList: GeneralListProps[];
}

export const FooterLinksList: FC<LinkWrapperProps> = ({ linksList, disableImages = false }) => {
  const navigate = useNavigate();
  const { theme } = useUserContext();

  const onClick = (link: GeneralListProps) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const { pageURL, isOpenInNewTab } = link;

    if (pageURL) {
      const processedPageURL = pageURL.replace(':activeBrand', theme);
      const isExternalUrl = checkIsUrlExternal(processedPageURL);
      const isNewWindow = isExternalUrl || isOpenInNewTab;

      isNewWindow ? openNewWindow(processedPageURL, '_blank') : navigate(processedPageURL);
    }
  };

  return (
    <div className="footer-links-list">
      {Children.toArray(
        linksList.map((link: GeneralListProps) => {
          const { imageURL, title } = link;

          return (
            <div
              className={joinStrings([
                'footer-links-list__item',
                link?.disabled && 'footer-links-list__item--disabled',
              ])}
            >
              <Link onClick={onClick(link)}>
                {imageURL && <LazyLoadedImage enabled={!disableImages} src={imageURL} alt={title} />}
                {title && <Paragraph noMargin>{title}</Paragraph>}
              </Link>
            </div>
          );
        })
      )}
    </div>
  );
};
